import { useNavigate } from "react-router-dom";

// Dosya indirme işlevini gerçekleştiren global fonksiyon
export const downloadFile = (url, filename) => {
  // `a` elementi oluşturuluyor
  const link = document.createElement("a");
  link.href = url;
  link.download = filename; // İndirilen dosyanın adı
  document.body.appendChild(link); // `a` elementini DOM'a ekleyin
  link.click(); // Programatik olarak tıklayarak indirme işlemini başlatın
  document.body.removeChild(link); // `a` elementini DOM'dan kaldırın
};

export const downloadPdf = (response, item) => {
  console.log("attachmentApi: ", response);
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = item.fileName ? `${item.fileName}` : 'filename.pdf';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
}

export const score2color = (score) => {
  if (score <= 6 && score > 5)
    return "#BA290C"; // Cok Zayıf (Very Weak)
  if (score <= 5 && score > 4)
    return "#DC6F59"; // Zayıf (Weak)
  if (score <= 4 && score > 3)
    return "#9E9E9E"; // Normal
  if (score <= 3 && score > 2)
    return "#61C101"; // Olumlu (Positive)
  if (score <= 2 && score >= 1)
    return "#158006"; // Cok Olumlu (Very Positive)
  return "#158006"; // Default color for invalid scores
};

export const score3color = (score) => {
  if (score <= 6 && score > 5)
    return "#BA290C"; //Cok Zayıf
  if (score <= 5 && score > 4)
    return "#DC6F59"; //Zayıf
  if (score <= 4 && score > 3)
    return "#9E9E9E"; //Normal
  if (score <= 3 && score > 2)
    return "#61C101"; //Olumlu
  if (score <= 2 && score >= 1)
    return "#158006"; //Cok Olumlu
  return "#158006";
}



export const cellToNavigate = (flex, navigate, filedName) => {
  flex.hostElement.addEventListener("click", (e) => {
    var ht = flex.hitTest(e);
    if (flex.columns[ht.col].binding == filedName) {
      let securityCode =
        ht.panel.rows[ht.row].dataItem[filedName] == undefined
          ? ht.panel.rows[ht.row].dataItem.equity
          : ht.panel.rows[ht.row].dataItem[filedName];

      if (securityCode == undefined) {
        return;
      }

      navigate("/StockAnalysis/summary/" + securityCode);
    }
  });
};

export const generateGUID = () => {
  // Her segment için rastgele hexadecimal string üreten fonksiyon
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  let res = `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`;
  console.count("generateGUID");
  // Tipik bir GUID formatında string oluşturma
  return res;
};

